<template>
	<div class="head">
		<!-- 二级标题 -->
		<div class="headb pointer" @click="$router.push('/')">
			<span>{{ title }} <span class="title2">{{title2}}</span></span>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'HeaderTwo',
		props: ["title", 'title2'],
		data() {
			return {};
		},
		created() {}
	};
</script>
<style scoped lang="less">
	.head {
		width: 100%;

		.headt {
			height: 75px;
			background-color: #f5f9fe;
		}

		.headb {
			color: #fff;
			height: 55px;
			line-height: 55px;
			padding: 0 40px;
			font-size: 30px;
			background: url('@img/common/header.jpg') 0 0 / cover no-repeat;
		}

		.title2 {
			font-size: 20px;
		}
	}
</style>